<template>
    <v-card elevation="2" >
        <v-card-title>Numbers</v-card-title>
        <v-card-text v-if="ready">
            <v-divider></v-divider>
            <v-row class="my-2">
                <v-col md="9">
                    <h3>Games played</h3>
                </v-col>
                <v-col align="end">
                    <h3>{{gameStats.games}}</h3>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="my-2">
                <v-col md="9">
                    <h3>Rounds played</h3>
                </v-col>
                <v-col align="end">
                    <h3>{{gameStats.rounds}}</h3>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="my-2">
                <v-col md="9">
                    <h3>Games ended in 2 rounds</h3>
                </v-col>
                <v-col align="end">
                    <h3>{{gameStats.shortGames}}</h3>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="my-2">
                <v-col md="9">
                    <h3>Games ended in 3 rounds</h3>
                </v-col>
                <v-col align="end">
                    <h3>{{gameStats.games - gameStats.shortGames}}</h3>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="my-2">
                <v-col md="9">
                    <h3>Beers consumed</h3>
                </v-col>
                <v-col align="end">
                    <h3>{{gameStats.beers}}</h3>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="my-2">
                <v-col md="9">
                    <h3>Price in A.le coq</h3>
                </v-col>
                <v-col align="end">
                    <h3>{{price}} €</h3>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="my-2">
                <v-col md="9">
                    <h3>Tölkeistä saatu</h3>
                </v-col>
                <v-col align="end">
                    <h3>{{returnPrice}} €</h3>
                </v-col>
            </v-row>
            <v-divider></v-divider>
        </v-card-text>
        <v-row v-if="!ready" justify="center" class="py-6">
            <v-progress-circular                
                :size="100"
                color="primary"
                indeterminate
            ></v-progress-circular>
        </v-row>
    </v-card>
</template>

<script>
    export default {
        name: "StatsCard",
        props: {
            gameStats: {
                type: Object,
                default: null
            },
        },
        computed: {
            ready() {
                return this.gameStats != null && this.gameStats.games != 0
            },
            price(){
                return Math.round(this.gameStats.beers * 1.24 * 100) / 100
            },
            returnPrice(){
                return Math.round(this.gameStats.beers * 0.15 * 100) / 100
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>